import React from "react";
import { Dialog, Button, Text, Box } from "@primer/react";
import { AlertIcon } from "@primer/octicons-react";

interface StaleFiltersModalPrimerProps {
  isOpen: boolean;
}

export const StaleFiltersModalPrimer: React.FC<StaleFiltersModalPrimerProps> = ({
  isOpen,
}) => {
  const handleReload = () => {
    window.location.reload();
  };

  if (!isOpen) return null;

  return (
    <Dialog
      title="Report Configuration Changed"
      onClose={handleReload}
      aria-labelledby="stale-filters-dialog-title"
    >
      <Dialog.Body>
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 3 }}>
          <Box sx={{ flexShrink: 0, color: "attention.fg" }}>
            <AlertIcon size={24} />
          </Box>
          <Text>
            This report references filters that no longer exist. Please reload
            the page to continue.
          </Text>
        </Box>
      </Dialog.Body>
      <Dialog.Footer>
        <Button variant="primary" onClick={handleReload}>
          Reload Page
        </Button>
      </Dialog.Footer>
    </Dialog>
  );
};
